const CLASSES = {
  default: "brh-slide-gallery",
  elements: {
    get main() {
      return `.${CLASSES.default}`;
    },
  },
};

export default CLASSES;
